<template>
  <div class="ordersummary">
    <div class="text-xs-left subheading font-weight-bold ">Order Summary</div>
    <v-container justify-center class="" column>
      <OrderSummaryItem label="Items" :value="cartItemPrice"></OrderSummaryItem>
      <OrderSummaryItem v-if="deliveryType == 'mail'" label="Shipping" :value="cartShipping"></OrderSummaryItem>
      <OrderSummaryItem v-if="chargeTax" label="Total before Tax:" :value="cartTotalBeforeTax"></OrderSummaryItem>
      <div v-if="taxDirty && chargeTax">
        <v-layout justify-space-around class="">
          <v-flex xs4 text-xs-left>Tax (press compute):</v-flex>
          <v-flex xs4 text-xs-right ><v-btn small @click="computeTax" label="Compute tax">Compute tax</v-btn></v-flex>
        </v-layout>
        <div v-if="taxErrors" class="error--text">
          {{taxErrors}}
        </div>
      </div>
      <OrderSummaryItem v-else-if="chargeTax" label="Tax:" :value="cartSalesTax"></OrderSummaryItem>
      <hr />
      <OrderSummaryItem class="accent--text title" label="Order Total:" :value="totalPrice"></OrderSummaryItem>

    </v-container>
  </div>
</template>

<script>
import {mapState, mapGetters} from 'vuex'
// import config from '../../../config.js'
import utils from '../../../utils.ts'
import OrderSummaryItem from './OrderSummaryItem'

export default {
  name: 'OrderSummary',
  components: {
    OrderSummaryItem
  },
  data: function () {
    return {
      helpTip: false,
      inperson: false,
      radioGroup: null,
      card: null,
      taxErrors: null
    }
  },
  computed: {
    ...mapState({
      cartId: state => state.cart.cartId,
      verified: state => state.buyerInfo.verified,
      deliveryAddress: state => state.cart.deliveryAddress,
      taxDirty: state => state.cart.taxDirty,
      chargeTax: state => state.shopping.public_settings.chargeTax,
      deliveryType: state => state.cart.deliveryType,
      orderSummaryHasErrors: state => state.cart.orderSummaryHasErrors
    }),
    ...mapGetters('cart', {
      cartItemPrice: 'cartItemPrice',
      cartTotalPrice: 'cartTotalPrice',
      cartShipping: 'cartShipping',
      cartTotalBeforeTax: 'cartTotalBeforeTax',
      cartSalesTax: 'cartSalesTax'
    }),
    totalPrice: function () {
      return utils.formatCurrency(this.cartTotalPrice)
    }
  },
  mounted: function () {
    this.computeTax()
  },
  methods: {
    hasError: function () {
      return this.taxErrors != null
    },
    computeTax: function () {
      console.log('CHARGE TAX: ' + this.chargeTax)
      if (!this.chargeTax) {
        this.$store.dispatch('cart/setTaxRate', 0)
        return
      }
      // addr1, addr2, addr3, city, state, zip, country

      const addr1 = this.deliveryAddress.street
      const addr2 = ''
      const addr3 = ''
      const city = this.deliveryAddress.city
      const state = this.deliveryAddress.state
      const zip = this.deliveryAddress.zip5
      const country = 'US'

      console.log('Computing tax')
      this.taxErrors = null
      utils.getTax(addr1, addr2, addr3, city, state, zip, country).then((resp) => {
        console.log('Tax Respon: ' + resp * 40)
        // Set the tax rate
        this.$store.dispatch('cart/setTaxRate', resp).then( () => {
            this.$store.commit('cart/setOrderSummaryHasErrors', false)
        })
      }).catch((err) => {
        console.error('Error computing tax:' + err)
        this.taxErrors = 'Could not compute tax. Problem with the delivery address'
        this.$store.commit('cart/setOrderSummaryHasErrors', true)
      })
    },
    getData: function () {
      // Returns the form data
      let theType = this.radioGroup
      if (this.onlyCreditCards) {
        theType = 'creditcard'
      } else if (this.onlyInPerson) {
        theType = 'inperson'
      }

      return {
        type: theType
      }
    },
    isValid: function () {
      this.$v.$touch()
      return this.$v.$invalid
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
